import formatDate from 'client/util/formatDate';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import styles from './AnalyzeEvolutionTooltip.css';

const deliveryActionMessages = defineMessages({
  shown: { id: 'Person.status.shown', defaultMessage: 'Survey shown' },
  responded: { id: 'Person.status.responded', defaultMessage: 'Survey responded' },
  commented: { id: 'Person.status.commented', defaultMessage: 'Survey commented' },
  sent: { id: 'Person.status.sent', defaultMessage: 'Survey sent' },
  opened: { id: 'Person.status.opened', defaultMessage: 'Survey opened' },
  scheduled: { id: 'Person.status.scheduled', defaultMessage: 'Survey scheduled' },
});

const STAGE_COLORS = ['#1976d2', '#7b1fa2', '#2e7d32', '#ed6c02', '#455a64'];

function DeliveryEvolutionTooltip({ contentTooltip, chartSeries, chartPeriod, funnelStages }) {
  const point = contentTooltip?.point;
  const { locale, formatMessage, formatNumber } = useIntl();

  if (!point?.key) {
    return null;
  }

  return (
    <div className={styles.tooltip}>
      <dl>
        <dt className={styles.date}>{formatDate(point.key, locale, chartPeriod === 'week')}</dt>
        <dd />
        {chartSeries.map((series, index) => {
          const stage = funnelStages?.find(s => s.action === series.field);
          const msg = deliveryActionMessages[series.field];
          const label = msg
            ? formatMessage(msg)
            : stage?.label || series.field;
          const count = point[series.field] ?? 0;
          return (
            <Fragment key={series.field}>
              <dt>
                <svg viewBox="0 0 15 10">
                  <path
                    stroke={series.color || STAGE_COLORS[index % STAGE_COLORS.length]}
                    strokeWidth={series.strokeWidth || 2}
                    d="M0 5L15 5"
                  />
                </svg>
                {label}
              </dt>
              <dd>{formatNumber(count)}</dd>
            </Fragment>
          );
        })}
      </dl>
    </div>
  );
}

DeliveryEvolutionTooltip.propTypes = {
  chartSeries: PropTypes.arrayOf(PropTypes.object).isRequired,
  chartPeriod: PropTypes.string.isRequired,
  funnelStages: PropTypes.arrayOf(PropTypes.object),
  contentTooltip: PropTypes.shape({
    point: PropTypes.object,
  }),
};

DeliveryEvolutionTooltip.defaultProps = {
  funnelStages: [],
  contentTooltip: { point: {} },
};

export default DeliveryEvolutionTooltip;
